// --- Payload methods
/**
 * Enum of JSON RPC methods for interacting with the Magic SDK authentication
 * relayer.
 */
export var MagicPayloadMethod;
(function (MagicPayloadMethod) {
    MagicPayloadMethod["LoginWithMagicLink"] = "magic_auth_login_with_magic_link";
    MagicPayloadMethod["LoginWithCredential"] = "magic_auth_login_with_credential";
    MagicPayloadMethod["GetIdToken"] = "magic_auth_get_id_token";
    MagicPayloadMethod["GenerateIdToken"] = "magic_auth_generate_id_token";
    MagicPayloadMethod["GetMetadata"] = "magic_auth_get_metadata";
    MagicPayloadMethod["IsLoggedIn"] = "magic_auth_is_logged_in";
    MagicPayloadMethod["Logout"] = "magic_auth_logout";
    MagicPayloadMethod["UpdateEmail"] = "magic_auth_update_email";
    MagicPayloadMethod["WebAuthnRegistrationStart"] = "magic_auth_webauthn_registration_start";
    MagicPayloadMethod["RegisterWithWebAuth"] = "magic_auth_webauthn_register";
    MagicPayloadMethod["LoginWithWebAuthn"] = "magic_auth_login_with_web_authn";
    MagicPayloadMethod["WebAuthnLoginVerfiy"] = "magic_auth_login_with_webauthn_verify";
    MagicPayloadMethod["GetWebAuthnInfo"] = "magic_user_get_webauthn_credentials";
    MagicPayloadMethod["UpdateWebAuthnInfo"] = "magic_user_update_webauthn";
    MagicPayloadMethod["UnregisterWebAuthDevice"] = "magic_user_unregister_webauthn";
    MagicPayloadMethod["RegisterWebAuthDeviceStart"] = "magic_auth_register_webauthn_device_start";
    MagicPayloadMethod["RegisterWebAuthDevice"] = "magic_auth_register_webauthn_device";
})(MagicPayloadMethod || (MagicPayloadMethod = {}));
//# sourceMappingURL=json-rpc-types.js.map